A profile for posting a job ad against an existing position opening.

This contains information of how a position opening is presented on a given channel or job board.
